export default __webpack_public_path__ + "static/marketing-plan-score-icon-a23a7a7a610b53601f48c52efa15755d.svg";